// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".BottomBoard__PanelContainer___SBRFg{bottom:0;left:50%;position:absolute;transform:translateX(-50%);transform-origin:bottom;width:-moz-fit-content;width:fit-content;z-index:100}.BottomBoard__BannerContainer___3RhPR,.BottomBoard__View___3Ab_Z{width:100%}.BottomBoard__View___3Ab_Z{display:flex;justify-content:center}@keyframes BottomBoard__popUp___1dYPo{0%{height:0}50%{height:20px}80%{height:45px}to{height:auto}}@keyframes BottomBoard__popDown___3D30v{0%{height:auto}20%{height:45px}50%{height:20px}to{height:0}}.BottomBoard__MountAnimation___3KA_q{animation:BottomBoard__popUp___1dYPo 1s linear;animation-play-state:running}.BottomBoard__UnmountAnimation___FrP8e{animation:BottomBoard__popDown___3D30v 1s linear;animation-play-state:running}.BottomBoard__InvisibleDiv___3xU_b{background:transparent;height:110px;width:95vw}", ""]);
// Exports
exports.locals = {
	"PanelContainer": "BottomBoard__PanelContainer___SBRFg",
	"BannerContainer": "BottomBoard__BannerContainer___3RhPR",
	"View": "BottomBoard__View___3Ab_Z",
	"MountAnimation": "BottomBoard__MountAnimation___3KA_q",
	"popUp": "BottomBoard__popUp___1dYPo",
	"UnmountAnimation": "BottomBoard__UnmountAnimation___FrP8e",
	"popDown": "BottomBoard__popDown___3D30v",
	"InvisibleDiv": "BottomBoard__InvisibleDiv___3xU_b"
};
module.exports = exports;
